import OAuthProvider from 'owa-service/lib/contract/OAuthProvider';
import { toggleConnectGmailWindow } from '../actions/connectGmail/toggleConnectGmailWindow';
import { updateGmailIsConnecting } from '../actions/connectGmail/updateGmailIsConnecting';
import { toggleEditAccountWindow } from '../actions/editAccount/toggleEditAccountWindow';
import { updateEditIsSaving } from '../actions/editAccount/updateEditIsSaving';
import { initConnectedAccountsFull } from '../orchestrators/initConnectedAccountsFull';
import { getEditAccountSyncRequest } from '../selectors/getEditAccountSyncRequest';
import { getRefreshToken } from '../services/getRefreshToken';
import { newSyncRequest } from '../services/newSyncRequest';
import { setSyncRequest } from '../services/setSyncRequest';
import { connectedAccountsStore } from '../store/store';

export async function connectGmailWithAuthCode(authorizationCode: string): Promise<void> {
    let store = connectedAccountsStore();

    try {
        if (store.dialogWindowState.connectGmailOpen) {
            updateGmailIsConnecting(true);
        } else if (store.dialogWindowState.editAccountOpen) {
            updateEditIsSaving(true);
        }

        let tokenResponse = await getRefreshToken(authorizationCode);

        if (!tokenResponse.ErrorMessage) {
            if (store.dialogWindowState.connectGmailOpen) {
                let response = await newSyncRequest({
                    EmailAddress: tokenResponse.OAuth2RefreshTokenInfo.EmailAddress,
                    Name: tokenResponse.OAuth2RefreshTokenInfo.EmailAddress,
                    DisplayName:
                        store.connectGmailState.displayName ||
                        tokenResponse.OAuth2RefreshTokenInfo.EmailAddress,
                    IncomingAuth: 'OAuth',
                    OAuthProvider: OAuthProvider.Google,
                    RefreshToken: tokenResponse.OAuth2RefreshTokenInfo.RefreshToken,
                    SyncProtocol: 'Imap',
                    IncomingServer: 'imap.gmail.com',
                    IncomingPort: 993,
                    SmtpServerName: 'smtp.gmail.com',
                    SmtpServerPort: 587,
                    IncomingSecurity: 'Ssl',
                    RemoteSendEnabled: true,
                    TargetRootFolder: store.connectGmailState.targetRootFolderEnabled
                        ? tokenResponse.OAuth2RefreshTokenInfo.EmailAddress
                        : null,
                });

                if (!response.ErrorMessage) {
                    initConnectedAccountsFull();
                }
            } else if (store.dialogWindowState.editAccountOpen) {
                let request = getEditAccountSyncRequest();
                request.RefreshToken = tokenResponse.OAuth2RefreshTokenInfo.RefreshToken;
                let response = await setSyncRequest(request);

                if (!response.ErrorMessage) {
                    initConnectedAccountsFull();
                }
            }
        }
    } finally {
        if (store.dialogWindowState.connectGmailOpen) {
            updateGmailIsConnecting(false);
            toggleConnectGmailWindow({ connectGmailOpen: false });
        } else if (store.dialogWindowState.editAccountOpen) {
            updateEditIsSaving(false);
            toggleEditAccountWindow({ editAccountOpen: false });
        }
    }
}
